import React from 'react'

const Footer = () => {
  return (
    <footer className="style-1">
      <div className="container">
        <div className="content">
          <div className="row justify-content-center">
            <div className="col-lg-4">
              <div className="foot_info">
                {/* <a href="#" className="logo mb-3"> */}
                {/* <img src="assets/img/logo_cl.png" alt=""> */}
                {/* </a> */}
                <div className="text mb-4">
                  <p>
                    ADVSKILL est une ESN française qui propose depuis 2014 son
                    expertise et ses conseils auprès d’un vaste panel
                    d’entreprises ( CAC40, ETI, PME et Startup ) dans les
                    nouvelles technologies ou des technologies plus anciennes.
                    L’équipe ADVSKILL est composée exclusivement d'Experts
                    techniques et managers confirmés.
                  </p>
                  <p>
                    ADVSKILL accompagne sur la durée la transformation IT de
                    nombreuses entreprises en Europe. Nos dirigeants issus du
                    monde du conseil, ayant travaillé pour plusieurs grands
                    comptes du CAC40 ont mis en place des techniques de
                    recrutement très évoluées permettant de sourcer des experts
                    dans leur domaine. Ces derniers analysent vos besoins afin
                    de vous proposer les solutions les plus adaptées.
                  </p>
                  {/* Theme for Your Busines */}
                </div>
                <ul className="mb-4">
                  <li className="d-flex">
                    <i className="bi bi-house me-3"></i>
                    {/* <a href="#"> */}
                    <span>Neuily-sur-Seine, Île-de-France</span>
                    {/* </a> */}
                  </li>
                  <li className="d-flex">
                    <i className="bi bi-envelope me-3"></i>
                    {/* <a href="#"> */}
                    <span>contact@advskill.com</span>
                    {/* </a> */}
                  </li>
                  <li className="d-flex">
                    <i className="bi bi-phone me-3"></i>
                    {/* <a href="#"> */}
                    <span>(+33) 1 76 43 34 21</span>
                    {/* </a> */}
                  </li>
                </ul>
                <div className="social_icons">
                  {/* <a href="#">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="#">
                      <i className="fab fa-facebook-f"></i>
                    </a> */}
                  <a
                    href="https://www.linkedin.com/company/advancetechnology/"
                    target="blank">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  {/* <a href="#">
                      <i className="fab fa-github"></i>
                    </a> */}
                </div>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="links">
                <div className="cont">
                  <h6 className="link_title">Services</h6>
                  <ul>
                    <li>
                      {/* <a href="#"> */}
                      IT Consultations
                      {/* </a> */}
                    </li>
                    {/* <li>
                        <a href="#">Data Security </a>
                      </li>
                      <li>
                        <a href="#">Website Development </a>
                      </li>
                      <li>
                        <a href="#">UI/UX Design </a>
                      </li>
                      <li>
                        <a href="#">Cloud Services </a>
                      </li>
                      <li>
                        <a href="#">Game Development </a>
                      </li>
                      <li>
                        <a href="#">CRM & Software </a>
                      </li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="links">
                <div className="cont">
                  <h6 className="link_title">Information</h6>
                  <ul>
                    <li>
                      {/* <a href="#"> */}A propos d'Advskill
                      {/* </a> */}
                    </li>
                    {/* <li>
                        <a href="#">Investors </a>
                      </li>
                      <li>
                        <a href="#">Blog </a>
                      </li>
                      <li>
                        <a href="#">Career </a>
                      </li>
                      <li>
                        <a href="#">Contact </a>
                      </li>
                      <li>
                        <a href="#">Affiliate Program </a>
                      </li>
                      <li>
                        <a href="#">How It Works </a>
                      </li>
                      <li>
                        <a href="#">Pricing Plan </a>
                      </li>
                      <li>
                        <a href="#">Covid-19 Update </a>
                      </li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="foot_subscribe">
                <h6 className="link_title">Newsletter</h6>
                <p>
                  Inscrivez-vous maintenant pour recevoir les dernières mises à
                  jour sur les promotions.
                </p>
                <div className="input-group my-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Entrer votre email"
                    aria-label="Entrer votre email"
                    aria-describedby="button-addon2"
                  />
                  <button
                    className="btn btn-gard border-0 text-white px-3 bg-[#1da1f2]"
                    type="button"
                    id="button-addon2">
                    <span>Souscrire</span>
                  </button>
                </div>
                <p className="fst-italic">
                  En vous inscrivant, vous avez accepté notre politique.
                  {/* <a href="#" className="text-decoration-underline">  */}
                  {/* </a> */}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="foot">
              <p>
                © 2023 Droits d'auteur par
                {/* <a href="#" className="text-white text-decoration-underline">  </a>  */}
                Tous les droits réservés de ADVSKILL
                {/* <a href="#" className="text-white text-decoration-underline"> */}
                {/* </a> */}
              </p>
            </div>
          </div>
        </div>
      </div>
      <img src="assets/img/footer/foot_l.png" alt="" className="foot_l" />
      <img src="assets/img/footer/foot_r.png" alt="" className="foot_r" />
    </footer>
  );
}

export default Footer